import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';
import { I18n, Utils, FormInput, Navigation, DateUtils, ActionButton } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import { updateOccHealthRequirements, resetStatus } from '../../employer/actions';
import { currentEmployerPermissions } from '../../../helpers/permissions';
import { BASE_SETUP_OCC_HEALTH } from '../../../constants/permissions';

function Row(props) {
  function handleReminderPress() {
    const r = props.r;

    props.resetStatus();
    Navigation.showModal({
      screen: 'OccHealthRequirementDetails',
      title: r.name + ' - Patient Reminders in Advance of Due Date',
      passProps: {
        requirement: r,
        onSave: handlePatientReminderSave,
      },
    });
  }

  function handleDocsPress() {
    const r = props.r;

    props.resetStatus();
    Navigation.showModal({
      screen: 'OccHealthDocs',
      title: `${r.name} Documents`,
      passProps: {
        requirement: r,
        createEmployerRequirement: handlePatientReminderSave,
      },
    });
  }

  function handlePatientReminderSave(requirement) {
    props.onSave(requirement);
  }

  function renderButtons() {
    const r = props.r;
    return (
      <View style={[THEME.basicRow, { justifyContent: 'center' }]}>
        <ActionButton
          source={require('../../../../resources/icon-form.png')}
          disabled={!props.canEdit}
          onPress={handleDocsPress}
          extraStyle={{ width: 17, height: 22 }}
        />
        <ActionButton
          source={require('../../../../resources/icon-notifications.png')}
          disabled={!props.canEdit}
          onPress={handleReminderPress}
          extraStyle={{ width: 20, height: 23 }}
        />
      </View>
    );
  }

  const r = props.r;
  const i = props.i;

  if (!__WEB__) {
    return (
      <View
        style={[
          THEME.basicRow,
          { backgroundColor: i % 2 === 0 ? COLOR.contrast : COLOR.altContrast },
        ]}
      >
        <View style={[THEME.rowColumn, { flex: 1 }]}>
          <Text style={THEME.rowText}>{r.name}</Text>
          <Text style={[THEME.rowText, THEME.linkStyle]}>{r.patient_reminder}</Text>
        </View>
        <View style={[THEME.rowColumn, { width: 100, justifyContent: 'flex-end' }]}>
          {renderButtons()}
        </View>
      </View>
    );
  } else {
    return (
      <View
        style={[
          THEME.basicRow,
          { backgroundColor: i % 2 === 0 ? COLOR.contrast : COLOR.altContrast },
        ]}
      >
        <View style={[THEME.rowColumn, { flexGrow: 1, width: 200 }]}>
          <Text style={THEME.rowText}>{r.name}</Text>
        </View>
        <View style={[THEME.rowColumn, { flexGrow: 1, width: 150 }]}>
          <Text style={[THEME.rowText, THEME.linkStyle]}>{r.patient_reminder}</Text>
        </View>
        <View style={[THEME.rowColumn, { width: 150 }]}>
          <Text style={THEME.rowText}>{DateUtils.formatDateStringNumeric(r.updated)}</Text>
        </View>
        <View style={[{ width: 100 }]}>{renderButtons()}</View>
      </View>
    );
  }
}

export default memo(
  connect(
    function (state, ownProps) {
      return {
        employer: getCurrentEmployer(state),
        occHealthRequirements: state.screens.employer.occHealthRequirementsData || [],
        canEdit: currentEmployerPermissions(BASE_SETUP_OCC_HEALTH).canEdit,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators(
          {
            updateOccHealthRequirements,
            resetStatus,
          },
          dispatch
        ),
      };
    }
  )(function (props) {
    function renderRequirementRow(r, i) {
      return (
        <Row
          r={r}
          key={`${r.master_requirement_id}`}
          i={i}
          onSave={handleReminderSave}
          canEdit={props.canEdit}
          resetStatus={props.actions.resetStatus}
        />
      );
    }

    function handleReminderSave(requirement) {
      props.actions.updateOccHealthRequirements(props.employer.employerId, requirement);
    }

    if (!__WEB__) {
      //return <View>{props.occHealthRequirements?.map?.(renderRequirementRow)}</View>;
      return null;
    } else {
      return (
        <View>
          <View style={THEME.sectionHeader}>
            <View style={[THEME.sectionHeaderColumn, { flexGrow: 1, width: 200 }]}>
              <Text style={THEME.sectionHeaderText}>REQUIREMENT</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { flexGrow: 1, width: 150 }]}>
              <Text style={THEME.sectionHeaderText}>PATIENT REMINDER</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { width: 150 }]}>
              <Text style={THEME.sectionHeaderText}>DATE UPDATED</Text>
            </View>
            <View style={[THEME.sectionHeaderColumn, { width: 100, borderRightWidth: 0 }]}>
              <Text style={THEME.sectionHeaderText}>ACTIONS</Text>
            </View>
          </View>
          <View>{props.occHealthRequirements?.map?.(renderRequirementRow)}</View>
        </View>
      );
    }
  })
);

const styles = StyleSheet.create({});
